import { render, staticRenderFns } from "./viewReport.vue?vue&type=template&id=64afc917&scoped=true"
import script from "./viewReport.vue?vue&type=script&lang=js"
export * from "./viewReport.vue?vue&type=script&lang=js"
import style0 from "./viewReport.vue?vue&type=style&index=0&id=64afc917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afc917",
  null
  
)

export default component.exports